/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { RESERVATION_DATA_VIEWS } from "./utils/constants";
import ReservationMainView from "./ReservationMainView";
import StudentListReservationView from "./StudentListReservationView";

const RegularReservationView = ({
	data,  space, reservation, 
    updateActivityPopup
}) => {
	const [viewIndex, setViewIndex] = useState(RESERVATION_DATA_VIEWS.MAIN_VIEW);
	useEffect(() => {
        updateActivityPopup.adjustPopupPosition();
    }, [viewIndex]);
	function goToListStudentReservationView() {
        setViewIndex(RESERVATION_DATA_VIEWS.STUDENT_RESERVATION_LIST);
    }
	const views = [
        <ReservationMainView
            data={data}
            updateActivityPopup={updateActivityPopup}
            reservation={reservation}
            space={space}
            goToListStudentReservationView={goToListStudentReservationView}/>,
        <StudentListReservationView
            data={data}
            space={space}
            updateActivityPopup={updateActivityPopup}
            reservation={reservation}/>
    ];
    return views[viewIndex];
}

export default RegularReservationView;